import React from 'react';
import { Col, Container, Row } from 'react-grid-system';
import Card from '../../components/Card/index';
import PageTitle from '../../components/PageTitle/index';
import { P1 } from '../../components/Typography/index';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import Button from '../../components/Button';

const Action = styled.div`
  padding: 16px 0 0;
  text-align: right;

  a {
    text-decoration: none;
  }
`;

const ClaimRemainingBalancePaymentSuccess: React.FC = () => {
  return (
    <Container>
      <Row>
        <Col lg={10} push={{ lg: 1 }}>
          <PageTitle>Payment Success</PageTitle>
          <Card>
            <P1 bold>Thank you! Your payment has been received.</P1>
            <P1>With that, your outstanding balance has been cleared and your Reposit will be closed down.</P1>
            <P1>Thank you for using Reposit!</P1>
          </Card>
          <Action>
            <NavLink to={`/`}>
              <Button>Take me to my dashboard</Button>
            </NavLink>
          </Action>
        </Col>
      </Row>
    </Container>
  );
};

export default ClaimRemainingBalancePaymentSuccess;
